<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  min-width="290px"
                  :disabled="status != 'DRAFT'"
                >
                  <v-text-field
                    slot="activator"
                    v-model="issueDate"
                    label="Issue Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="issueDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockTransferRequest.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No."
                  v-model="stockTransferRequest.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex
                sm12
                v-if="stockTransferRequest.id && user.role.roleName == 'ADMIN'"
              >
                <v-autocomplete
                  v-model="stockTransferRequest.status"
                  :items="adminStatusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="
                    status == 'FINISHED'
                      ? true
                      : status == 'CANCEL'
                      ? true
                      : status == 'REJECT'
                      ? true
                      : false
                  "
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                sm12
                v-if="
                  stockTransferRequest.id &&
                  (user.role.roleName == 'WAREHOUSE_MANAGER' ||
                    user.role.roleName == 'WAREHOUSE_STAFF')
                "
              >
                <v-autocomplete
                  v-model="stockTransferRequest.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :readonly="
                    status == 'FINISHED'
                      ? true
                      : status == 'CANCEL'
                      ? true
                      : status == 'REJECT'
                      ? true
                      : status == 'CONFIRM'
                      ? true
                      : false
                  "
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="stockTransferRequest.fromWarehouseId"
                  :items="activeWarehouseList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="From Warehouse"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  v-on:change="checkSameWarehouse()"
                  :rules="[
                    () =>
                      !!stockTransferRequest.fromWarehouseId ||
                      'From warehouse is required. ',
                  ]"
                  :readonly="
                    status != 'DRAFT' ||
                    user.role.roleName == 'WAREHOUSE_MANAGER' ||
                    user.role.roleName == 'WAREHOUSE_STAFF' ||
                    user.role.roleName == 'BRANCH_ADMIN'
                  "
                ></v-autocomplete>
                <h3
                  v-if="isError"
                  style="color: #ff5252; font: 12px Roboto, sans-serif"
                >
                  {{ error }}
                </h3>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="stockTransferRequest.toWarehouseId"
                  :items="activeWarehouseList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="To Warehouse"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  v-on:change="checkSameWarehouse()"
                  :rules="[
                    () =>
                      !!stockTransferRequest.toWarehouseId ||
                      'To warehouse is required. ',
                  ]"
                  :readonly="status != 'DRAFT'"
                ></v-autocomplete>
                <h3
                  v-if="isError"
                  style="color: #ff5252; font: 12px Roboto, sans-serif"
                >
                  {{ error }}
                </h3>
              </v-flex>
              <v-flex sm12>
                <v-layout>
                  <v-flex sm10>
                    <v-text-field
                      name="stockTemplateName"
                      label="Stock Template Name"
                      v-model="stockTransferRequest.stockTemplateName"
                      type="text"
                      :readonly="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm2>
                    <v-btn
                      outline
                      color="warning"
                      :disabled="status != 'DRAFT'"
                      @click="showStockTemplate()"
                    >
                      Search
                      <v-icon dark>search</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="stockTransferRequest.description"
                  type="text"
                  :rules="rules.descriptionRules"
                  :readonly="status != 'DRAFT'"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockTransferRequest.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockTransferRequest.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="stockTransferRequest.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="stockTransferRequest.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="stockTransferRequest.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="stockTransferRequest.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addStockTransferRequestItem()"
                    :disabled="status != 'DRAFT'"
                  >
                    Add Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                  <v-flex xs6 ml-4>
                    <v-text-field
                      name="scanBarcode"
                      label="Scan barcode....."
                      v-model="scanBarcode"
                      type="text"
                      v-on:keyup.enter="trigger(scanBarcode)"
                      prepend-icon="filter_center_focus"
                      :disabled="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs3>Code</v-flex>
                  <v-flex xs3>Name</v-flex>
                  <v-flex xs2>Unit</v-flex>
                  <v-flex xs1>Qty</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(
                    stockTransferRequestItem, index
                  ) in stockTransferRequest.stockTransferRequestItems"
                  :key="index"
                >
                  <v-flex xs3>
                    <v-text-field
                      v-if="status == 'DRAFT'"
                      placeholder="Select the code"
                      v-model="stockTransferRequestItem.productCode"
                      @click.stop="showProducts(), (selectedIndex = index)"
                      :rules="rules.codeRules"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      placeholder="Select the code"
                      v-model="stockTransferRequestItem.productCode"
                      :rules="rules.codeRules"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="stockTransferRequestItem.productName"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      placeholder="Name"
                      readonly
                      :rules="rules.productNameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-autocomplete
                      v-model="stockTransferRequestItem.factorUnitName"
                      :items="stockTransferRequestItem.productUnits"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      placeholder="Select"
                      @change="(option) => changeFactorUnit(option, index)"
                      :rules="rules.unitRules"
                      :readonly="status != 'DRAFT'"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="stockTransferRequestItem.qty"
                      min="0"
                      :rules="rules.qtyRules"
                      :readonly="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      name="remark"
                      placeholder="Remark"
                      v-model="stockTransferRequestItem.remark"
                      type="text"
                      :rules="rules.remarkRules"
                      :readonly="status != 'DRAFT'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="
                        removeStockTransferRequestItem(
                          index,
                          stockTransferRequestItem.id
                        )
                      "
                      :disabled="status != 'DRAFT' || index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="
                      !valid || 
                      saveLoading || 
                      (status == 'REQUEST' &&
                        this.fromWarehouseId == this.warehouseId) ||
                      (this.user.roleName != 'ADMIN' && status == 'CONFIRM') ||
                      status == 'REJECT'
                    "
                    @click="onSave"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Product List Dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Selection -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.produtGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- product list selection -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setProduct(props.item.code, selectedIndex),
                        (showProductListDialog = !showProductListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.code }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Stock Template list dialog -->
    <v-dialog
      v-model="showStockTemplateListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                v-model="stockTemplateQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="stockTemplateOnSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :must-sort="true"
                :headers="stockTemplateHeaders"
                :items="stockTemplateList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="stockTemplateTotalRows"
                :rows-per-page-items="stockTemplateRowsPerPageItems"
                :pagination.sync="stockTemplatePagination"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      prepareStockTransferRequestItems(props.item),
                        (showStockTemplateListDialog =
                          !showStockTemplateListDialog)
                    "
                  >
                    <a>{{ props.item.name }}</a>
                  </td>
                  <td>{{ props.item.status }}</td>
                  <td>{{ props.item.description }}</td>
                  <td>
                    {{
                      props.item.updatedDateInMilliSeconds | formatMsDateTime
                    }}
                  </td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { StockTransferRequest, StockTemplateItem } from "../../models/model";
import { StockTransferRequestItem } from "../../models/model";
import { StockTransferRequestFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
import { productService } from "../../services/product-service";
import { stockTemplateService } from "../../services/stock-template-service";
import { stockTransferRequestService } from "../../services/stock-transfer-request-service";
import { warehouseService } from "../../services/warehouse-service";

export default {
  name: "StockTransferRequestDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Stock Transfer Request List",
        disabled: false,
        to: "stock-transfer-requests",
      },
      {
        text: "Stock Transfer Request Detail",
        disabled: true,
      },
    ],
    showListLoading: false,
    saveLoading: false,
    messageDialogBox: false,
    showProductListDialog: false,
    showStockTemplateListDialog: false,
    warehouseId: "",
    fromWarehouseId: "",
    createdDate: "",
    updatedDate: "",
    responseError: "",
    error: "",
    isError: false,
    status: "DRAFT",
    issueDate: "",
    activeWarehouseList: [],
    productList: [],
    statusList: [],
    adminStatusList: [],
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    stockTemplateHeaders: [
      { text: "Name", value: "name" },
      { text: "Status", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      isPurchase: true,
    },
    stockTemplateTotalRows: 0,
    stockTemplateQueryParams: {
      name: "",
      status: "",
    },

    stockTemplateRowsPerPageItems: [10, 50, 100],
    stockTemplatePagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    stockTemplateList: [],
    totalRows: 0,
    stockTransferRequest: new StockTransferRequest(),
    oldStockTransferRequest: new StockTransferRequest(),
    stockTransferRequestItem: new StockTransferRequestItem(),
    rules: new StockTransferRequestFormRules(),
    scanBarcode: "",
  }),

  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },

  created() {
    if (
      this.user.roleName == "WAREHOUSE_MANAGER" ||
      this.user.roleName == "WAREHOUSE_STAFF" ||
      this.user.roleName == "BRANCH_ADMIN"
    ) {
      this.stockTransferRequest.fromWarehouseName = this.user.warehouseName;
      this.stockTransferRequest.fromWarehouseId = this.user.warehouseId;
      this.warehouseId = this.user.warehouseId;
    }
    this.fromWarehouseId = this.user.warehouseId;
    this.getActiveWarehouses();
    const id = this.$route.params.id;
    if (id == "new") {
      // new Stock Transfer Request
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.addStockTransferRequestItem();
    } else {
      this.getStockTransferRequestDetail(id);
    }
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },

    checkSameWarehouse() {
      if (
        this.stockTransferRequest.toWarehouseId ==
        this.stockTransferRequest.fromWarehouseId
      ) {
        this.isError = true;
        this.error = "To and From warehouse must be different.";
      } else {
        this.isError = false;
      }
    },

    getActiveWarehouses() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.activeWarehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.stockTransferRequest.stockTransferRequestItems[index].productCode =
        product.code;
      this.stockTransferRequest.stockTransferRequestItems[index].productName =
        product.name;
      //set default unit
      var j = "";
      for (var i = 0; i < product.productUnits.length; i++) {
        if (product.productUnits[i].basicUnit == true) j = i;
      }
      this.stockTransferRequest.stockTransferRequestItems[index].productUnitId =
        product.productUnits[j].id;
      this.stockTransferRequest.stockTransferRequestItems[
        index
      ].factorUnitName = product.productUnits[j].factorUnitName;
      this.stockTransferRequest.stockTransferRequestItems[index].productUnits =
        product.productUnits;
      this.stockTransferRequest.stockTransferRequestItems[index].qty = 0;
      this.stockTransferRequest.stockTransferRequestItems[index].remark = "";
    },

    getStockTransferRequestDetail(id) {
      stockTransferRequestService
        .getStockTransferRequestDetail(id)
        .then((res) => {
          this.stockTransferRequest = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.stockTransferRequest.createdDateInMilliSeconds)
              .toISOString()
              .substring(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.stockTransferRequest.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          this.fromWarehouseId = res.data.fromWarehouseId;
          this.toWarehouseId = res.data.toWarehouseId;
          if (this.fromWarehouseId == this.warehouseId) {
            this.statusList = [];
            if (res.data.status == "DRAFT") {
              this.statusList.push("DRAFT", "REQUEST", "CANCEL");
            }
            if (res.data.status == "REQUEST") {
              this.statusList.push("REQUEST");
            }
            if (res.data.status == "CANCEL") {
              this.statusList.push("CANCEL");
            }
            if (res.data.status == "REJECT") {
              this.statusList.push("REJECT");
            }
            if (res.data.status == "CONFIRM") {
              this.statusList.push("CONFIRM");
            }
            if (res.data.status == "FINISHED") {
              this.statusList.push("FINISHED");
            }
          }
          if (this.toWarehouseId == this.warehouseId) {
            this.statusList = [];
            if (res.data.status == "REQUEST") {
              this.statusList.push("REQUEST", "REJECT", "CONFIRM");
            }
            if (res.data.status == "CONFIRM") {
              this.statusList.push("CONFIRM");
            }
            if (res.data.status == "REJECT") {
              this.statusList.push("REJECT");
            }
            if (res.data.status == "DRAFT") {
              this.statusList.push("DRAFT");
            }
            if (res.data.status == "CANCEL") {
              this.statusList.push("CANCEL");
            }
            if (res.data.status == "FINISHED") {
              this.statusList.push("FINISHED");
            }
          }
          if (this.user.role.roleName == "ADMIN") {
            if (res.data.status == "DRAFT") {
              this.adminStatusList.push("DRAFT", "REQUEST", "CANCEL");
            }
            if (res.data.status == "REQUEST") {
              this.adminStatusList.push("REQUEST", "CANCEL", "FINISHED");
            }
            if (res.data.status == "CONFIRM") {
              this.adminStatusList.push("CONFIRM", "FINISHED");
            }
            if (res.data.status == "REJECT") {
              this.adminStatusList.push("REJECT");
            }
            if (res.data.status == "CANCEL") {
              this.adminStatusList.push("CANCEL");
            }
            if (res.data.status == "FINISHED") {
              this.adminStatusList.push("FINISHED");
            }
          }

          this.issueDate = commonService.millisecondToDate(
            this.stockTransferRequest.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.status = this.stockTransferRequest.status;
          //deep copy
          this.oldStockTransferRequest = JSON.parse(JSON.stringify(res.data));
          this.getActiveWarehouses();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addStockTransferRequestItem() {
      //deep copy
      let stockTransferRequestItem = JSON.parse(
        JSON.stringify(this.stockTransferRequestItem)
      );
      this.stockTransferRequest.stockTransferRequestItems.push(
        stockTransferRequestItem
      );
    },

    showStockTemplate() {
      // Clean query params
      this.stockTemplateQueryParams.page = this.stockTemplatePagination.page;
      this.stockTemplateQueryParams.rowsPerPage =
        this.stockTemplatePagination.rowsPerPage;
      this.getStockTemplateList().then(
        (this.showStockTemplateListDialog = !this.showStockTemplateListDialog)
      );
    },

    prepareStockTransferRequestItems(item) {
      var stockTransferRequest = this.stockTransferRequest;
      stockTransferRequest.stockTemplateName = item.name;
      //clear previous datas
      stockTransferRequest.stockTransferRequestItems = [];

      let stockTemplateItems = item.stockTemplateItems;
      if (stockTemplateItems) {
        stockTemplateItems.forEach((item) => {
          let stockTemplateItem = JSON.parse(
            JSON.stringify(new StockTemplateItem())
          );
          stockTemplateItem.productCode = item.productCode;
          stockTemplateItem.productName = item.productName;
          stockTemplateItem.factorUnitName = item.factorUnitName;
          stockTemplateItem.productUnits = item.productUnits;
          stockTemplateItem.qty = item.qty;
          // Push stock template item to stock transfer items
          stockTransferRequest.stockTransferRequestItems.push(
            stockTemplateItem
          );
        });
      }
    },

    getStockTemplateList() {
      this.showListLoading = true;
      this.stockTemplateQueryParams.status = "ACTIVE";
      let order = this.stockTemplatePagination.descending ? "desc" : "asc";
      return stockTemplateService
        .getStockTemplateList(
          this.stockTemplateQueryParams,
          this.stockTemplatePagination.page,
          this.stockTemplatePagination.rowsPerPage,
          this.stockTemplatePagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockTemplateList = res.data.stockTemplateList;
            this.stockTemplateTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    showProducts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";

      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },

    removeStockTransferRequestItem(index, stockTransferRequestItemId) {
      if (stockTransferRequestItemId) {
        // add delete stockTransfer item id
        if (!this.stockTransferRequest.deleteStockTransferRequestItemIds) {
          this.stockTransferRequest.deleteStockTransferRequestItemIds = [];
        }
        this.stockTransferRequest.deleteStockTransferRequestItemIds.push(
          stockTransferRequestItemId
        );
      }
      this.$delete(this.stockTransferRequest.stockTransferRequestItems, index);
    },

    goBack() {
      this.$router.push("/stock-transfer-requests");
    },

    stockTemplateOnSearch() {
      this.stockTemplateQueryParams.page = this.stockTemplatePagination.page;
      this.stockTemplateQueryParams.rowsPerPage =
        this.stockTemplatePagination.rowsPerPage;
      this.getStockTemplateList();
    },

    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          // convet to millisecond
          this.stockTransferRequest.issueDateInMilliSeconds =
            commonService.convertToMilliseconds(this.issueDate);
          stockTransferRequestService
            .saveStockTransferRequest(this.stockTransferRequest)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
                this.messageDialogBox = true;
              }
              this.saveLoading = false;
            });
        }
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.stockTransferRequest.id) {
        this.stockTransferRequest = new StockTransferRequest();
        this.addStockTransferRequestItem();
      } else {
        this.stockTransferRequest = Object.assign(
          {},
          this.oldStockTransferRequest
        );
      }
      this.stockTransferRequest.fromWarehouseId = this.user.warehouseId;
    },
    trigger(barcode) {
      if (barcode) {
        this.getProductUnitByBarcode(barcode);
      }
    },
    getProductUnitByBarcode(bcode) {
      let params = {
        barcode: bcode,
      };
      productService
        .getProductUnitByBarcode(params)
        .then((res) => {
          let productUnit = res.data;
          if (productUnit) {
            this.setProductByBarcode(productUnit);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.scanBarcode = "";
        });
    },

    setProductByBarcode(productUnit) {
      if (
        this.stockTransferRequest.stockTransferRequestItems[0].productCode == ""
      ) {
        // if the first stockTransferRequest item is empty init object
        this.addValuesToFirstStockTransferRequestItem(productUnit);
      } else if (this.isItemExist(productUnit)) {
        this.addQtyToExistingStockTransferRequestItem(productUnit);
      } else {
        this.addNewItemToStockTransferRequestItemList(productUnit);
      }
    },
    addQtyToExistingStockTransferRequestItem(productUnit) {
      this.stockTransferRequest.stockTransferRequestItems.forEach((item) => {
        if (item.productUnitId === productUnit.id) {
          item.qty = Math.abs(item.qty) + 1;
        }
      });
    },
    isItemExist(productUnit) {
      for (let item of this.stockTransferRequest.stockTransferRequestItems) {
        if (item.productUnitId === productUnit.id) {
          return true;
        }
      }
    },
    addValuesToFirstStockTransferRequestItem(productUnit) {
      this.stockTransferRequest.stockTransferRequestItems[0].productCode =
        productUnit.product.code; // productCode
      this.stockTransferRequest.stockTransferRequestItems[0].productName =
        productUnit.product.name; // productName
      this.stockTransferRequest.stockTransferRequestItems[0].productUnitId =
        productUnit.id; //productUnitId
      this.stockTransferRequest.stockTransferRequestItems[0].productUnits.push(
        productUnit
      ); // productUnits[]
      this.stockTransferRequest.stockTransferRequestItems[0].factorUnitName =
        productUnit.factorUnitName; // factorUnitName
      this.stockTransferRequest.stockTransferRequestItems[0].qty = 1; // qty
    },
    addNewItemToStockTransferRequestItemList(productUnit) {
      // get new init StockTransferRequest Item
      let stockTransferRequestItem = JSON.parse(
        JSON.stringify(this.stockTransferRequestItem)
      );
      stockTransferRequestItem.productCode = productUnit.product.code; // productCode
      stockTransferRequestItem.productName = productUnit.product.name; // productName
      stockTransferRequestItem.productUnitId = productUnit.id; //productUnitId
      stockTransferRequestItem.productUnits[0] = productUnit; // productUnits[]
      stockTransferRequestItem.factorUnitName = productUnit.factorUnitName; // factorUnitName
      stockTransferRequestItem.qty = 1; // qty

      this.stockTransferRequest.stockTransferRequestItems.push(
        stockTransferRequestItem
      );
    },
    changeFactorUnit(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.stockTransferRequest.stockTransferRequestItems[index].productUnits
      );
      if (this.checkItemDuplicate(productUnit, index)) {
        let item = productUnit.product.name + " (" + factorUnitName + ")";
        this.responseError =
          "Stock Transfer Request Item: " + item + " is duplicated";
        this.messageDialogBox = true;
      }
      this.stockTransferRequest.stockTransferRequestItems[index].productUnitId =
        productUnit.id;
    },
    checkItemDuplicate(productUnit, index) {
      for (let item in this.stockTransferRequest.stockTransferRequestItems) {
        if (item != index) {
          if (
            this.stockTransferRequest.stockTransferRequestItems[item]
              .productUnitId === productUnit.id
          ) {
            return true;
          }
        }
      }
    },
  },
};
</script>